import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import DrawerLoader from '../../../commands/utils/DrawerLoader';

import { closeDrawer, getProduct } from '../../stockActions';
import StockItem from '../StockItem';

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  }
}));

/**
 * Drawer permettant d'afficher les informations de la commande dans la partie
 * stock
 * @param {Boolean}  isOpen              Status du drawer ouver ou fermer
 * @param {Function} dispatchCloseDrawer Function permettant de fermer le drawer
 * @param {Object}   currentItem         Object representer l'objet à afficher dans le drawer
 * @param {Boolean}  loading             Indiquer si la rêquete est en cours
 */
const StockItemDrawer = ({
  isOpen,
  dispatchCloseDrawer,
  currentItem,
  loadingCurrentItem
}) => {
  const classes = useStyles();
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
      }}
      open={isOpen}
    >
      {loadingCurrentItem ? (
        <DrawerLoader />
      ) : (
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <h1>
            {currentItem.name} - {currentItem.reference}
          </h1>
          <StockItem />
        </div>
      )}
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => ({
  isOpen: state.stock.openDrawer,
  currentItem: state.stock.currentItem,
  loadingCurrentItem: state.stock.loadingCurrentItem
});

const mapDispatchToProps = dispatch => ({
  dispatchGetProduct: id => dispatch(getProduct(id)),
  dispatchCloseDrawer: () => dispatch(closeDrawer())
});

StockItemDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dispatchCloseDrawer: PropTypes.func.isRequired,
  currentItem: PropTypes.object.isRequired,
  loadingCurrentItem: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(StockItemDrawer);
